import { isOthersGroupLabel } from "utils/groupBy/isOthersGroupLabel";

import { IChartResult } from "models/model";

import { ChartDataTableColumn, ChartDataTableRow } from "../hooks/useDataTableData";

const GROUP_COLUMN_KEY = "group";
const VALUE_COLUMN_KEY = "value";

// NOTE: Changing this logic should result in changes to the chart-svc backend export logic.
/**
 * Client data table for the Rig/Frac Recent Activity chart (EVA-76): a
 * single-value shape — a group column and a value column, one row per group,
 * sorted descending by value to match the ranked horizontal bars.
 */
const getRigFracRecentActivityDataTable = (
  responseData: IChartResult
): { columns: ChartDataTableColumn[]; rows: ChartDataTableRow[] } => {
  const series = responseData?.series ?? [];

  // The backend emits a VERTICAL-bar layout: layout.xAxis.title is the GROUP
  // dimension ("Operator") and layout.yAxis.title the METRIC ("Rig Count") —
  // same convention the rigFracRecentActivity translator and the chart-svc
  // export (BuildRecentActivityDataTable) read.
  const columns: ChartDataTableColumn[] = [
    {
      key: GROUP_COLUMN_KEY,
      name: responseData?.layout?.xAxis?.title ?? "Group",
      resizable: false
    },
    {
      key: VALUE_COLUMN_KEY,
      name: responseData?.layout?.yAxis?.title ?? "Count",
      resizable: false
    }
  ];

  const rows: ChartDataTableRow[] = series
    .map((s) => {
      const value = s.y?.[0];
      return {
        [GROUP_COLUMN_KEY]: s.label,
        [VALUE_COLUMN_KEY]: typeof value === "number" ? value : ""
      };
    })
    // Others last, matching the bars and the export.
    .sort(
      (a, b) =>
        Number(isOthersGroupLabel(String(a[GROUP_COLUMN_KEY]))) -
          Number(isOthersGroupLabel(String(b[GROUP_COLUMN_KEY]))) ||
        Number(b[VALUE_COLUMN_KEY]) - Number(a[VALUE_COLUMN_KEY])
    );

  return {
    columns,
    rows
  };
};

export default getRigFracRecentActivityDataTable;
